export default __webpack_public_path__ + "static/icon-tile-bold-do-461a36556079f2e90ba96aa3d92c969df3c394e8f2f567bc960919ead9de5a77.png";